/* Salas García · Etiquetas en español: "Sold out" -> "Agotado" y "Sale" -> "Oferta" */
(function () {
  function run() {
    document.querySelectorAll('.card-wrapper .badge').forEach(function (b) {
      if (b.children.length) return;
      var t = b.textContent.trim();
      if (/^sold out$/i.test(t)) b.textContent = 'Agotado';
      else if (/^sale$/i.test(t)) b.textContent = 'Oferta';
    });
  }
  function init() {
    run();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 30);
    }).observe(document.body, { subtree: true, childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
